import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Typography,
  TextField,
  FormControlLabel,
  Checkbox,
  Button,
  IconButton,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import { updateEventObject } from "../../../../../data-store/actions/events-actions";
import { showSnackbar } from "../../../../../data-store/actions/organizers-actions";
import {
  siguienteClaveMoneda,
  aplicarMonedaGuardada,
  eliminarMoneda,
  esMonedaBase,
  puedeEliminar,
} from "./monedaLogic";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: "20px",
    textAlign: "left",
  },
}));

const RUTA_MONEDA = "inscripcionesConfiguracion/configuracion/moneda/";

export default function MonedaForm({ monedaKey, moneda, monedas, onGuardado }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const eventDetail = useSelector((state) => state.events.eventDetail);

  const [codigo, setCodigo] = useState(moneda ? moneda.codigo : "");
  const [texto, setTexto] = useState(moneda ? moneda.texto : "");
  const [cambioAPeso, setCambioAPeso] = useState(
    moneda ? String(moneda.cambioAPeso) : ""
  );
  const [esBase, setEsBase] = useState(moneda ? esMonedaBase(moneda) : !monedaKey ? Object.keys(monedas || {}).length === 0 : false);
  const [error, setError] = useState("");

  const editandoLaBaseActual = Boolean(monedaKey) && esMonedaBase(moneda);
  const eventoIndex = "evento_" + eventDetail.iDEvento;

  function guardar() {
    setError("");
    const codigoLimpio = (codigo || "").trim().toUpperCase();
    const textoLimpio = (texto || "").trim();
    const cambioNumero = parseFloat(cambioAPeso);

    if (!codigoLimpio || !textoLimpio) {
      setError("Código y texto a mostrar son requeridos.");
      return;
    }
    if (!cambioNumero || cambioNumero <= 0) {
      setError("El tipo de cambio a pesos debe ser un número mayor a 0.");
      return;
    }

    const clave = monedaKey || siguienteClaveMoneda(monedas);
    const monedaGuardada = {
      codigo: codigoLimpio,
      texto: textoLimpio,
      cambioAPeso: cambioNumero,
      tipo: esBase ? "base" : "opcional",
    };

    const monedasFinal = aplicarMonedaGuardada(monedas, clave, monedaGuardada);

    dispatch(updateEventObject(eventoIndex, RUTA_MONEDA, monedasFinal));
    dispatch(showSnackbar(true, "Moneda guardada", 3000));
    if (onGuardado) onGuardado();
  }

  function eliminar() {
    const check = puedeEliminar(monedas, monedaKey);
    if (!check.permitido) {
      setError(check.motivo);
      return;
    }
    const monedasFinal = eliminarMoneda(monedas, monedaKey);
    dispatch(updateEventObject(eventoIndex, RUTA_MONEDA, monedasFinal));
    dispatch(showSnackbar(true, "Moneda eliminada", 3000));
    if (onGuardado) onGuardado();
  }

  return (
    <Grid container direction="column" className={classes.paper} spacing={2}>
      <Grid item xs={12}>
        <Typography gutterBottom variant={"h5"} component="h2">
          {monedaKey ? "Editar moneda" : "Crear moneda"}
        </Typography>
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Código (ej. USD, EUR, MXN)"
          fullWidth
          value={codigo}
          onChange={(e) => setCodigo(e.target.value)}
          inputProps={{ maxLength: 6 }}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="Texto a mostrar al atleta (ej. Dólares americanos)"
          fullWidth
          value={texto}
          onChange={(e) => setTexto(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <TextField
          label="¿Cuántos pesos mexicanos equivale 1 unidad de esta moneda?"
          helperText="Se usa para calcular el monto que se envía a la pasarela de pago, que siempre recibe pesos mexicanos."
          type="number"
          fullWidth
          value={cambioAPeso}
          onChange={(e) => setCambioAPeso(e.target.value)}
        />
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel
          control={
            <Checkbox
              checked={esBase}
              disabled={editandoLaBaseActual}
              onChange={(e) => setEsBase(e.target.checked)}
              color="primary"
            />
          }
          label="Esta es la moneda base del evento"
        />
        {editandoLaBaseActual && (
          <Typography variant="body2" color="textSecondary">
            Para cambiar la moneda base, marca otra moneda como base en su
            propio formulario.
          </Typography>
        )}
      </Grid>
      {error && (
        <Grid item xs={12}>
          <Typography color="error">{error}</Typography>
        </Grid>
      )}
      <Grid item xs={12}>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Button variant="contained" color="primary" onClick={guardar}>
              Guardar
            </Button>
          </Grid>
          {monedaKey && (
            <Grid item>
              <IconButton onClick={eliminar} aria-label="eliminar moneda">
                <DeleteIcon />
              </IconButton>
            </Grid>
          )}
        </Grid>
      </Grid>
    </Grid>
  );
}
